module.exports = __webpack_public_path__ + "static/media/tick.443d2090.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tick.svg
// module id = 831
// module chunks = 7